import Vue from "vue";
import Vuex from "vuex";
import { SubscriptionService } from "@zoox-framework/messenger-helper";

Vue.use(Vuex);

const cleanState = {
  loading: 0,
  currentOrder: null,
  currentCharge: {},
  currentCompany: {},
  currentCompanyParams: {},
  chargeToken: null,
  paymentValue: 0,
  isValidated: false,
  isPaymentValid: false,
  terms: null,
  virtualWallet: true,
  pushNotificationService: new SubscriptionService()
};

const Store = new Vuex.Store({
  state: Object.assign({}, cleanState),
  mutations: {
    "loader/START_LOADING": function(state, payload) {
      if (payload.showLoading) {
        state.loading = state.loading + 1;
      }
    },
    "loader/FINISH_LOADING": function(state, payload) {
      if (payload.showLoading) {
        state.loading = state.loading - 1;
      }
    },
    setCurrentCharge: function(state, payload) {
      state.currentCharge = payload;
    },
    setCurrentCompany: function(state, payload) {
      state.currentCompany = payload;
    },
    setCurrentCompanyParams: function(state, payload) {
      state.currentCompanyParams = payload;
    },
    setChargeToken: function(state, payload) {
      state.chargeToken = payload;
    },
    setPaymentValue: function(state, payload) {
      state.paymentValue = payload;
    },
    setIsValidated: function(state, payload) {
      state.isValidated = payload;
    },
    setIsPaymentValid: function(state, payload) {
      state.isPaymentValid = payload;
    },
    setEnableVirtualWallet: function(state, payload) {
      state.virtualWallet = payload;
    },
    setTerms: function(state, payload) {
      state.terms = payload;
    },
    setCurrentOrder: function(state, payload) {
      state.currentOrder = payload;
    }
  },
  actions: {
    $setCurrentCharge: function(state, value) {
      state.commit("setCurrentCharge", value);
    },
    $setCurrentCompany: function(state, value) {
      state.commit("setCurrentCompany", value);
    },
    $setCurrentCompanyParams: function(state, value) {
      state.commit("setCurrentCompanyParams", value);
    },
    $setChargeToken: function(state, value) {
      state.commit("setChargeToken", value);
    },
    $setPaymentValue: function(state, value) {
      state.commit("setPaymentValue", value);
    },
    $setIsValidated: function(state, value) {
      state.commit("setIsValidated", value);
    },
    $setIsPaymentValid: function(state, value) {
      state.commit("setIsPaymentValid", value);
    },
    $setEnableVirtualWallet: function(state, value) {
      state.commit("setEnableVirtualWallet", value);
    },
    $setTerms: function(state, value) {
      state.commit("setTerms", value);
    },
    $setCurrentOrder: function(state, value) {
      state.commit("setCurrentOrder", value);
    }
  },
  getters: {
    getTerms(state) {
      return state.terms;
    },
    getCurrentCompany(state) {
      return state.currentCompany;
    },
    getCurrentCompanyParams(state) {
      return state.currentCompanyParams;
    },
    getCurrentCharge(state) {
      return state.currentCharge;
    },
    getChargeToken(state) {
      return state.chargeToken;
    },
    getCurrentOrder(state) {
      return state.currentOrder;
    }
  }
});

window.__zooxStore = Store;

export default Store;
